export default "__VITE_ASSET__byoVEX0d__"